import React from 'react'
import { useNavigate } from 'react-router-dom'

// Click → deep-link to /catalog filtered by just this dimension=value.
// The filter travels in the URL (like MatrixCell and the Intersections
// links) and CatalogBrowser's mount hydration applies it to the store.
// Writing the store first and navigating to a bare /catalog doesn't work:
// hydration re-reads the (empty) URL and wipes the filter (FE-3).
export default function DimensionTag({ dimensionSlug, value, dense = false, className = '' }) {
  const navigate = useNavigate()

  if (!value) return null

  const handleClick = (e) => {
    e.preventDefault()
    const params = new URLSearchParams()
    params.set(`dimension[${dimensionSlug}]`, value.slug)
    navigate(`/catalog?${params.toString()}`)
  }

  const sizeClasses = dense
    ? 'px-2 py-0.5 text-[11px]'
    : 'px-2.5 py-0.5 text-xs'

  return (
    <button
      type="button"
      onClick={handleClick}
      title={`Filter by ${dimensionSlug}: ${value.name}`}
      className={`inline-flex items-center rounded-full border border-slate-200 bg-white font-medium text-slate-700 transition hover:border-accent-300 hover:bg-accent-50 hover:text-accent-700 ${sizeClasses} ${className}`}
    >
      {value.name}
    </button>
  )
}
